import json5 from "refractor/json5";
export default json5;